import issuesReducer from './issues/issues.slice';
import { baseApi } from './services/base.service';
import authReducer from './services/auth.service';
import appReducer from './app/app.slice';
import menuListReducer from './groups/menu-list.slice';
import batchMenuReducer from './global-nav/batch-menu.slice';
import permissionsReducer from './permissions/permissions.slice';

export const reducers = {
  auth: authReducer,
  issues: issuesReducer,
  menuList: menuListReducer,
  batchMenu: batchMenuReducer,
  [baseApi.reducerPath]: baseApi.reducer,
  app: appReducer,
  permissions: permissionsReducer,
};

export default reducers;
